import { render, staticRenderFns } from "./WeightedAverageInfo.vue?vue&type=template&id=413e4ad6&scoped=true&"
import script from "./WeightedAverageInfo.vue?vue&type=script&lang=js&"
export * from "./WeightedAverageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413e4ad6",
  null
  
)

export default component.exports